module.exports = __webpack_public_path__ + "static/media/DSCF6373_PRIMERA_APARICION.60ed7c10.jpg";